module.exports = __webpack_public_path__ + "static/media/about.ae296ee7.md";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXs/content/about.md
// module id = 1260
// module chunks = 0